"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { FaTrash, FaMoneyBillWave } from "react-icons/fa";
import "../styles/FinanceiroDono.css"; 

export default function DespesasCircuitoAdmin() {
  const [circuitos, setCircuitos] = useState([]);
  const [circuitoSelecionado, setCircuitoSelecionado] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [despesas, setDespesas] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchCircuitos = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://api.ticketdovaqueiro.com/api/circuitos", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCircuitos(res.data);
      } catch (err) { console.error(err); }
    };
    fetchCircuitos();
  }, []);

  const fetchDespesas = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuitoSelecionado}/despesas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDespesas(res.data);
      setTotal(res.data.reduce((acc, d) => acc + d.valor, 0));
    } catch (err) { console.error(err); }
  };

  useEffect(() => {
    if (circuitoSelecionado) fetchDespesas();
  }, [circuitoSelecionado]);

  const salvarDespesa = async () => {
    if (!descricao || !valor) return alert("Preencha descrição e valor.");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoSelecionado}/despesas`,
        { descricao, valor: parseFloat(valor) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDescricao("");
      setValor("");
      fetchDespesas();
    } catch (err) { alert("Erro ao salvar."); }
  };

  const excluirDespesa = async (id) => {
    if (!window.confirm("Deseja realmente excluir?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`https://api.ticketdovaqueiro.com/api/circuitos/despesas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchDespesas();
    } catch (err) { alert("Erro ao excluir."); }
  };

  return (
    <div className="financeiro-containerdono">
      <h2><FaMoneyBillWave /> Despesas dos Circuitos</h2>

      <div className="descricao-extrato">
        <label>Selecione o Circuito:</label>
        <select value={circuitoSelecionado} onChange={(e) => setCircuitoSelecionado(e.target.value)}>
          <option value="">-- Escolha um circuito --</option>
          {circuitos.map((c) => (
            <option key={c._id} value={c._id}>{c.nome}</option>
          ))}
        </select>
      </div>

      {circuitoSelecionado && (
        <>
          <div className="grid-itemdono destaque">
            <h4>Total de Despesas deste Circuito</h4>
            <p>R$ {total.toLocaleString('pt-BR', {minimumFractionDigits: 2})}</p>
          </div>

          <div className="descricao-extrato">
            <input type="text" placeholder="Descrição da Despesa" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
            <input type="number" placeholder="Valor (R$)" value={valor} onChange={(e) => setValor(e.target.value)} />
            <button className="botao-saque" onClick={salvarDespesa}>Adicionar</button>
          </div>

          <div className="table-responsive">
            <table className="extrato-tabela">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th>Data/Hora</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {despesas.length === 0 ? <tr><td colSpan="4" style={{textAlign:"center"}}>Nenhuma despesa.</td></tr> : null}
                {despesas.map((d) => (
                  <tr key={d._id}>
                    <td>{d.descricao}</td>
                    <td style={{color: "#ef4444", fontWeight: "bold"}}>- R$ {d.valor.toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                    <td>{new Date(d.dataCriacao).toLocaleString("pt-BR")}</td>
                    <td><FaTrash className="icone-acao vermelho" onClick={() => excluirDespesa(d._id)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}